import styled from 'styled-components'
import { Box } from 'pcln-design-system'

export const ExpressBox = styled(Box)`
  display: block;
  height: 350px;
`

export const ImageBox = styled(Box)`
  position: absolute;
  right: 0;
`

export const WrapBox = styled(Box)`
  position: relative;
`

ExpressBox.displayName = 'ExpressBox'
ImageBox.displayName = 'ImageBox'
WrapBox.displayName = 'WrapBox'
